import React from 'react';
export function Footer() {
  return <footer className="bg-charcoal text-white py-12 border-t-4 border-gold" data-id="element-130">
      <div className="max-w-container mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-131">
        <div className="mb-6" data-id="element-132">
          <h2 className="font-serif font-bold text-2xl tracking-wide mb-2" data-id="element-133">
            ZENTRAL PRO™
          </h2>
        </div>

        <div className="flex flex-col sm:flex-row justify-center items-center gap-4 sm:gap-8 text-base text-gray-300 mb-8" data-id="element-134">
          <a href="mailto:soporte.zentralpro@gmail.com" className="hover:text-gold transition-colors" data-id="element-135">
            soporte.zentralpro@gmail.com
          </a>
          <span className="hidden sm:inline text-gray-600" data-id="element-136">|</span>
          <a href="https://instagram.com/_zentralpro" className="hover:text-gold transition-colors" data-id="element-137">
            @_zentralpro
          </a>
        </div>

        <div className="border-t border-white/10 pt-8 text-sm text-gray-500" data-id="element-138">
          <p data-id="element-139">© Zentral Pro™ 2026 — Todos los derechos reservados.</p>
        </div>
      </div>
    </footer>;
}